import { Component, ElementRef, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { TransferredVehicleServiceService } from 'src/app/services/vehicles/transferred-vehicle.service';
import { GlobalService } from 'src/app/services/shared/global.service';
import { AuthService } from 'src/app/services/auth/auth.service';

@Component({
  selector: 'app-view-transferred-vehicle',
  templateUrl: './view-transferred-vehicle.component.html',
  styleUrls: ['./view-transferred-vehicle.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class ViewTransferredVehicleComponent implements OnInit{
  public isLoading: boolean = false;
  public errorMessage: string | null = null;
  public successMessage: string | null = null;
  public transfer_log_id: string | null = null;
  vehicle: any;
  photos: any[] = [];
  spare_parts: any[] = [];
  spare_parts_columns: any[] = [];
  activity_logs: any[] = [];
  files: File[] = [];
  public userPermissions: string[] = [];
  selectedPhotos: any[] = []; // Array to store selected photos to delete
  public delPhotosPopupErrorMessage: string | null = null;
  public addSparePartsPopupErrorMessage: string | null = null;
  public removeSparePartsPopupErrorMessage: string | null = null;
  @ViewChild('DeletePhotosModal') modalDeletePhotos!: ElementRef;
  @ViewChild('AddSparePartsModal') modalAddSpareParts!: ElementRef;
  @ViewChild('RemoveSparePartsModal') modalRemoveSpareParts!: ElementRef;
  sparePartsToRemove: any[] = []; // Array to store selected spare parts to remove
  addtl_spare_parts: any[] = [];
  sparePartsToAdd: any[] = []; // Array to store selected additional spare parts
  addtl_spare_parts_page: number = 1;
  addtl_spare_parts_count: number = 0;
  remove_spare_parts_page: number = 1;
  remove_spare_parts_count: number = 0;
  searchAddtlPartsText: string = '';
  searchPartsToRemoveText: string = '';

  constructor(
    private activatedRoute:ActivatedRoute,
    private transferredVehicleServiceService: TransferredVehicleServiceService,
    private globalService: GlobalService,
    private authService: AuthService,
  ){}

  ngOnInit(): void {
    this.activatedRoute.paramMap.subscribe((param: Params)=>{
      this.transfer_log_id = param['get']('transfer_log_id')
    })

    if(this.transfer_log_id){
      this.isLoading=true;
      this.getVehicleData(this.transfer_log_id);
    }else{
      this.errorMessage="Oops! A problem was encountered while processing your request. Please refresh the page and try again!";
    }

    this.userPermissions=this.authService.getPermissions();
  }

  /**
   * Get vehicle details
   * @param transfer_log_id 
   */
  getVehicleData(transfer_log_id: string): void{
    this.transferredVehicleServiceService.getTransferredVehicleDetails(transfer_log_id)
    .subscribe({
      next: (response) => {
        if (response && Object.keys(response).length === 0) {
          this.isLoading=false;
          this.errorMessage="Oops! A problem was encountered while processing your request. Please refresh the page and try again!";
        }else{
          this.vehicle = response;
          if(this.vehicle.status==='no_data' || this.vehicle.status.length===0){
            this.isLoading=false;
            this.errorMessage="Oops! A problem was encountered while processing your request. Please refresh the page and try again.";
          }else{
            this.getVehicleSpareParts(transfer_log_id); //Load spare parts
            this.getVehiclePhotos(transfer_log_id); //Load photos
            this.getVehicleActivityLogs(transfer_log_id) //Load activity logs
          }
        }
      },
      error: (error) => {
        this.isLoading=false;
        this.errorMessage=error;
      }
    });
  }

  /**
   * Get vehicle photos
   * @param transfer_log_id 
   */
  getVehiclePhotos(transfer_log_id: string|null):void
  {
    this.transferredVehicleServiceService.fetchVehiclePhotos(transfer_log_id)
    .subscribe({
      next: (response) => {
        if(response.status==='success'){
          this.photos = response.data;
        }else if(response.status==='no_data'){
          this.errorMessage=response.message;
        }else{
          this.errorMessage="Sorry, a problem was encountered while loading vehicle photos. Please refresh the page and try again!";
        }
      },
      error: (error) => {
        this.isLoading=false;
        this.errorMessage=error;
      }
    });
  }

  getVehicleSpareParts(transfer_log_id: string|null):void {
    this.transferredVehicleServiceService.fetchVehicleSpareParts(transfer_log_id)
    .subscribe({
      next: (response) => {
        if(response.status==='success'){
          this.spare_parts = response.data;
          this.spare_parts_columns = this.splitIntoColumns(this.spare_parts, 10);
        }else if(response.status==='no_data'){
          this.errorMessage=response.message;
        }else{
          this.errorMessage="Sorry, a problem was encountered while loading spare parts. Please refresh the page and try again!";
        }
      },
      error: (error) => {
        this.errorMessage=error;
      }
    });
  }

  splitIntoColumns(items: any[], itemsPerColumn: number): any[] {
    const columns = [];
    for (let i = 0; i < items.length; i += itemsPerColumn) {
        columns.push(items.slice(i, i + itemsPerColumn));
    }

    return columns;
  }

   /**
   * Get vehicle activity logs
   * @param transfer_log_id 
   */
   getVehicleActivityLogs(transfer_log_id: string|null):void
   {
     this.transferredVehicleServiceService.fetchVehicleActivityLogs(transfer_log_id)
     .subscribe({
       next: (response) => {
         if(response.status==='success'){
           this.isLoading=false;
           this.activity_logs = response.data;
         }else if(response.status==='no_data'){
           this.isLoading=false;
         }else{
           this.isLoading=false;
           this.errorMessage="Sorry, a problem was encountered while loading vehicle activity logs. Please refresh the page and try again!";
         }
       },
       error: (error) => {
         this.isLoading=false;
         this.errorMessage=error;
       }
     });
   }

  openDeletePhotosModal(event: Event){
    event.preventDefault();
    if (this.modalDeletePhotos) {
      (<any>$(this.modalDeletePhotos.nativeElement)).modal('show');
    }
  }

  closeModal():void {
    if (this.modalDeletePhotos) {
      (<any>$(this.modalDeletePhotos.nativeElement)).modal('hide');
    }
  }

  /**
   * Delete photos
   */
  deletePhotos(){
    if(this.selectedPhotos.length===0){
      this.delPhotosPopupErrorMessage="Please select photo(s) to delete!";
    }else{
      this.isLoading = true;

      this.transferredVehicleServiceService.deleteVehicleTransferPhotos(this.vehicle.data.vehicle_id,this.selectedPhotos)
      .subscribe({
        next: (response) => {
          if(response.status==='success'){
            this.globalService.setGlobalSuccessMessage(response.message);
            this.errorMessage=''; //Clear error message incase it's available
            this.closeModal(); //Close modal
            this.getVehiclePhotos(this.transfer_log_id); // Reload transfer photos
            this.selectedPhotos=[];  //Cleared photos selected for deletion
            this.photos=[]; //Clear photo gallery
          }else if(response.status==='error'){
            this.isLoading=false;
            this.delPhotosPopupErrorMessage = response.message;
            this.errorMessage=''; //Clear any caught error message incase it's available
          }else if(response.status==='partial_delete'){
            this.globalService.setGlobalErrorMessage(response.message);
            this.errorMessage=''; //Clear any caught error message incase it's available
            this.closeModal();  //Close modal
            // Reload vehicle photos
            this.getVehiclePhotos(this.transfer_log_id);
            //Cleared selected photos
            this.selectedPhotos=[];
          }else{
            this.isLoading=false;
            this.closeModal();  //Close modal
            this.errorMessage=response.message;
          }
        },
        error: (error) => {
          this.isLoading=false;
          this.closeModal();  //Close modal
          this.errorMessage=error;
        }
      });
    }   
  }

  // Select and unselect photos to delete
  checkboxChange(event: any, item: any) {
    if (event.target.checked) {
      // Add checked photo to the array
      this.selectedPhotos.push(item);
    } else {
      // Remove unchecked photo from the array
      const index = this.selectedPhotos.indexOf(item);
      if (index !== -1) {
        this.selectedPhotos.splice(index, 1);
      }
    }
  }

  openAddSparePartsModal(event: Event,transfer_log_id: string|null){
    event.preventDefault();
    this.isLoading=true;

    this.transferredVehicleServiceService.fetchAdditionalSpareParts(transfer_log_id)
    .subscribe({
      next: (response) => {
        if(response.status==='success'){
          this.addtl_spare_parts = response.data;
          this.addtl_spare_parts_count=this.addtl_spare_parts.length;
          
          //Close spinner
          this.isLoading=false;
          //Open modal
          if (this.modalAddSpareParts) {
            (<any>$(this.modalAddSpareParts.nativeElement)).modal('show');
          }
        }else if(response.status==='no_data'){
          this.errorMessage=response.message;
        }else{
          this.errorMessage="Sorry, a problem was encountered while processing your request. Please refresh the page and try again!";
        }
      },
      error: (error) => {
        this.errorMessage=error;
      }
    });
  }

  closeAddSparePartsModal():void {
    if (this.modalAddSpareParts) {
      (<any>$(this.modalAddSpareParts.nativeElement)).modal('hide');
    }
  }

   // Function to handle checkbox change event
   addSparePartCheckboxChange(event: any, item: any) {
    if (event.target.checked) {
      // Add checked checkbox to the array
      this.sparePartsToAdd.push(item);
    } else {
      // Remove unchecked checkbox from the array
      const index = this.sparePartsToAdd.indexOf(item);
      if (index !== -1) {
        this.sparePartsToAdd.splice(index, 1);
      }
    }
  }

  onSearchAddtlSparePartsChange(event: Event) {
    this.searchAddtlPartsText = (event.target as HTMLInputElement).value;
  }

  addSparePartsPageChangeEvent(event: number){
    this.addtl_spare_parts_page = event;
  }

  addSpareParts(){
    if(this.transfer_log_id=="" || this.transfer_log_id==undefined){

      this.globalService.setGlobalErrorMessage("Unable to add more spare parts. Please try again!");

    }else if(this.sparePartsToAdd.length===0){

      this.addSparePartsPopupErrorMessage="Please select spare parts to proceed!";

    }else{
      this.isLoading = true;

      this.transferredVehicleServiceService.addSpareParts(this.vehicle.data.vehicle_id,this.vehicle.data.chassis_no,this.transfer_log_id,this.sparePartsToAdd)
      .subscribe({
        next: (response) => {
          if(response.status==='success'){
            this.globalService.setGlobalSuccessMessage(response.message);
            this.errorMessage=''; //Clear error message incase it's available
            this.closeAddSparePartsModal(); //Close modal
            this.getVehicleSpareParts(this.transfer_log_id); // Reload transfer photos
            this.getVehicleActivityLogs(this.transfer_log_id); // Reload activity logs
            this.sparePartsToAdd=[];  //Cleared selected spare parts
            this.isLoading=false;
          }else if(response.status==='error'){
            this.isLoading=false;
            this.addSparePartsPopupErrorMessage = response.message;
            this.errorMessage=''; //Clear any caught error message incase it's available
            this.sparePartsToAdd=[];  //Cleared selected spare parts
          }else{
            this.isLoading=false;
            this.closeAddSparePartsModal();  //Close modal
            this.errorMessage=response.message;
            this.sparePartsToAdd=[];  //Cleared selected spare parts
          }
        },
        error: (error) => {
          this.isLoading=false;
          this.closeAddSparePartsModal();  //Close modal
          this.errorMessage=error;
          this.sparePartsToAdd=[];  //Cleared selected spare parts
        }
      });
    }
  }

  openRemoveSparePartsModal(event: Event){
    event.preventDefault();
    this.remove_spare_parts_count = this.spare_parts.length;
    this.remove_spare_parts_page = 1;
    
    if (this.modalRemoveSpareParts) {
      (<any>$(this.modalRemoveSpareParts.nativeElement)).modal('show');
    }
  }

  closeRemoveSparePartsModal():void {
    if (this.modalRemoveSpareParts) {
      (<any>$(this.modalRemoveSpareParts.nativeElement)).modal('hide');
    }
  }

  // Function to handle checkbox change event
  removeSparePartCheckboxChange(event: any, item: any) {
    if (event.target.checked) {
      // Add checked checkbox to the array
      this.sparePartsToRemove.push(item);
    } else {
      // Remove unchecked checkbox from the array
      const index = this.sparePartsToRemove.indexOf(item);
      if (index !== -1) {
        this.sparePartsToRemove.splice(index, 1);
      }
    }
  }

  onSearchSparePartsToRemoveChange(event: Event) {
    this.searchPartsToRemoveText = (event.target as HTMLInputElement).value;
  }

  removeSparePartsPageChangeEvent(event: number){
    this.remove_spare_parts_page = event;
  }

  removeSpareParts(){
    if(this.transfer_log_id=="" || this.transfer_log_id==undefined){

      this.globalService.setGlobalErrorMessage("Unable to remove spare parts. Please try again!");

    }else if(this.sparePartsToRemove.length===0){

      this.removeSparePartsPopupErrorMessage="Please select spare parts to proceed!";

    }else{
      this.isLoading = true;

      this.transferredVehicleServiceService.removeSpareParts(this.vehicle.data.vehicle_id,this.vehicle.data.chassis_no,this.transfer_log_id,this.sparePartsToRemove)
      .subscribe({
        next: (response) => {
          if(response.status==='success'){
            this.globalService.setGlobalSuccessMessage(response.message);
            this.errorMessage=''; //Clear error message incase it's available
            this.closeRemoveSparePartsModal(); //Close modal
            this.getVehicleSpareParts(this.transfer_log_id); // Reload transfer photos
            this.getVehicleActivityLogs(this.transfer_log_id); // Reload activity logs
            this.sparePartsToRemove=[];  //Cleared selected spare parts
            this.isLoading=false;
          }else if(response.status==='error'){
            this.isLoading=false;
            this.removeSparePartsPopupErrorMessage = response.message;
            this.errorMessage=''; //Clear any caught error message incase it's available
            this.sparePartsToRemove=[];  //Cleared selected spare parts
          }else{
            this.isLoading=false;
            this.closeRemoveSparePartsModal();  //Close modal
            this.errorMessage=response.message;
            this.sparePartsToRemove=[];  //Cleared selected spare parts
          }
        },
        error: (error) => {
          this.isLoading=false;
          this.closeRemoveSparePartsModal();  //Close modal
          this.errorMessage=error;
          this.sparePartsToRemove=[];  //Cleared selected spare parts
        }
      });
    }
  }
}
